import { CoordinatesModel } from '@marketplace-web/shipping/checkout-shipping-data'

import { AddressModel } from '@marketplace-web/address/address-data'
import {
  LabelType,
  LabelOptionsLabelType,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

export type FetchNearbyDropOffPointsArgs = {
  selectedLabelType?: LabelType | LabelOptionsLabelType | null
  address?: AddressModel | null
  coordinates?: CoordinatesModel
  dropOffPointSource?: string | null
  limit?: number
}

export const DropOffPointSource = {
  UserAddress: 'user_address',
  CurrentLocation: 'current_location',
  SearchAreaButton: 'search_area_button',
  SearchBarAddress: 'search_bar_address',
}
